import script from "./PayResult.vue?vue&type=script&setup=true&lang=js"
export * from "./PayResult.vue?vue&type=script&setup=true&lang=js"

import "./PayResult.vue?vue&type=style&index=0&id=468c0d17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-468c0d17"]])

export default __exports__